import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Subscribe from "../../../components/Library/Subscribe";
import styles from "./Header.css";

class Header extends Component {
  render() {
    return (
      <div className={classNames(styles.header, this.props.className)}>
        <div className={styles.content}>
          {this.props.subText && <div className={styles.subText}>{this.props.subText}</div>}
          <div className={styles.mainText}>{this.props.text}</div>
          {this.props.subscription && <Subscribe className={styles.subscribe} subscription={this.props.subscription}/>}
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  subText: PropTypes.string,
  text: PropTypes.string,
  subscription: PropTypes.object,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Library/Header/Header.js